export default function (state, data) {
    state.settings = data;
}